import { PacIntroCallNoteAnswers } from '@bariendo/lib/pac-intro-call-note';
import { PatientTimeZone } from '@bariendo/lib/patient-time-zone';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

// Extended here as well as in `main.tsx`: these read `.tz()` on the patient's
// zone, and a unit test rendering them does not boot the app. `extend` is
// idempotent.
dayjs.extend(utc);
dayjs.extend(timezone);

function text(answers: PacIntroCallNoteAnswers, id: string): string {
  const value = answers.values[id];
  return typeof value === 'string' ? value : '';
}

/**
 * The one-line value a section shows when collapsed.
 *
 * Two of the four sections capture nothing — the opening is three lines the rep
 * reads, and the FAQs are read only when asked for — so they stay blank rather
 * than claiming a tick off "the rep says they read it". Section ticks are off on
 * this card for the same reason.
 *
 * The booked time is rendered in the **patient's** zone, matching the grid it
 * was picked from: a summary reading `Thu · 2:00pm` beside a grid that offered
 * `11:00am` is worse than no summary at all.
 */
export function summarizePacIntroCallBeat(
  beatId: string,
  answers: PacIntroCallNoteAnswers,
  timeZone?: PatientTimeZone
): string {
  switch (beatId) {
    case 'book': {
      if (!answers.slot) return '';
      const start = timeZone ? dayjs(answers.slot.start).tz(timeZone.timeZone) : dayjs(answers.slot.start);
      return start.isValid() ? start.format('ddd · h:mma') : '';
    }

    case 'notes':
      return text(answers, 'close');

    default:
      return '';
  }
}
